import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import { Switch } from "./ui/switch";
import { API } from "../App";
import { formatApiError } from "../lib/utils";

export const PaymentSettingsCard = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/payments/settings`, { withCredentials: true })
      .then((r) => setSettings(r.data))
      .catch((e) => toast.error(formatApiError(e, "Could not load payment settings")));
  }, []);

  const toggle = async (live) => {
    try {
      const r = await axios.put(`${API}/admin/payments/settings`, { mode: live ? "live" : "test" }, { withCredentials: true });
      setSettings(r.data);
      toast.success(`Payments switched to ${r.data.mode} mode`);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (!settings) return null;
  const live = settings.mode === "live";
  const ready = live ? settings.live_configured : settings.test_configured;

  return (
    <div className="bg-zinc-900 border border-zinc-800 p-6" data-testid="payment-settings-card">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h3 className="font-heading text-xl text-white flex items-center gap-2">
            <CreditCard className="h-5 w-5 text-orange-500" /> Peach Payments
          </h3>
          <p className="text-sm text-zinc-500 mt-1">
            {live ? "Live mode — real cards are charged." : "Test mode — no real money moves."}
          </p>
          <p className={`text-xs mt-1 ${ready ? "text-emerald-400" : "text-red-400"}`} data-testid="payment-settings-status">
            {ready ? `${settings.mode} credentials connected` : `${settings.mode} credentials missing — checkout is disabled`}
          </p>
        </div>
        <label className="flex items-center gap-3 text-sm text-zinc-300">
          Test
          <Switch checked={live} onCheckedChange={toggle} data-testid="payment-mode-switch" />
          Live
        </label>
      </div>
    </div>
  );
};
